import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("hp_cookie_notice")) setShow(true); }, []);
  if (!show) return null;
  const ok = () => { localStorage.setItem("hp_cookie_notice", "1"); setShow(false); };
  return (
    <div className="fixed bottom-20 lg:bottom-5 left-3 right-3 lg:left-auto lg:right-5 lg:max-w-md z-[90] bg-hp-dark border border-white/10 shadow-2xl p-4 flex gap-3 items-start" data-testid="cookie-banner">
      <Cookie className="text-hp-yellow shrink-0 mt-0.5" size={20} />
      <div className="text-xs text-neutral-300 leading-relaxed">
        Ce site n'utilise que des traceurs strictement nécessaires à son fonctionnement (centre choisi, panier). Aucun suivi publicitaire.{" "}
        <Link to="/confidentialite" className="text-hp-yellow underline underline-offset-2">En savoir plus</Link>
        <div className="mt-3"><button onClick={ok} className="hp-cta text-xs px-4 py-2" data-testid="cookie-accept">J'ai compris</button></div>
      </div>
    </div>
  );
}
